import { ActiveGroup, Experiment } from 'services/Firebase/utils/experiments';
import { useExperimentGroup } from 'services/Firebase/hooks/useExperimentGroup';

import ConfirmationModalWithDiscountControl from './ConfirmationModalWithDiscountControl';
import ConfirmationModalWithDiscountA from './ConfirmationModalWithDiscountA';

const ConfirmationModalWithDiscount = () => {
    const variant = useExperimentGroup(Experiment.CancelPostOfferAcceptanceABTest);

    switch (variant) {
        case ActiveGroup.A:
            return <ConfirmationModalWithDiscountA />;

        case ActiveGroup.Control:
            return <ConfirmationModalWithDiscountControl />;

        default:
            return <ConfirmationModalWithDiscountControl />;
    }
};

export default ConfirmationModalWithDiscount;
